import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_URI || "http://localhost:5000/api/v1",
});

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_API_SUB_URI || "ws://localhost:5000/subscriptions",
  options: {
    reconnect: true,
  },
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

export const graphqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: splitLink,
});
